import { SESSION_TIMER_DECREMENT, SESSION_TIMER_RESET } from '@engine/actions/action-types';
import { MAX_SESSION_TIME_IN_SECONDS } from '@engine/constants';
/**
 * Initial state
 */

var INITIAL_STATE = MAX_SESSION_TIME_IN_SECONDS;
/**
 * Reducer
 */

function sessionTimeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SESSION_TIMER_DECREMENT:
      return state - 1;

    case SESSION_TIMER_RESET:
      return INITIAL_STATE;

    default:
      return state;
  }
}

export default sessionTimeReducer;